<mat-card class="theme-card">
  <h3>🎨 Theme Picker</h3>

  <div class="color-inputs">
    <mat-form-field appearance="outline">
      <mat-label>Headers</mat-label>
      <input matInput type="color" [(ngModel)]="primary">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Background</mat-label>
      <input matInput type="color" [(ngModel)]="accent">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Sidbar,Navbar,Footer</mat-label>
      <input matInput type="color" [(ngModel)]="surfaceVariant">
    </mat-form-field>
  </div>

  <mat-slide-toggle [(ngModel)]="isDarkMode" (change)="onDarkModeToggle($event)">
    Dark Mode
  </mat-slide-toggle>

  <div class="btn-container">
    <button mat-raised-button color="primary" (click)="applyTheme()">Apply</button>
    <button mat-stroked-button color="warn" (click)="reset()">Reset</button>
  </div>
</mat-card>
